import React, { useState } from "react";
import EligibilityDetail from "./eligibility-detail";
import ActionModal from "./modals/action-modal";

// Accepts a 32-hex-char GUID with or without dashes (Phoenix uses both
// formats in URLs and database columns).
const GUID_REGEX =
  /^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}$/i;

const PatientLookupPanel = () => {
  const [input, setInput] = useState("");
  const [error, setError] = useState(null);
  const [selectedGuid, setSelectedGuid] = useState(null);

  const handleSubmit = e => {
    e.preventDefault();
    const trimmed = input.trim();
    if (!trimmed) return;
    if (!GUID_REGEX.test(trimmed)) {
      setError(
        "That does not look like a patient GUID (expected 32 hex characters, with or without dashes). Grab one from the patient's URL."
      );
      return;
    }
    setError(null);
    setSelectedGuid(trimmed);
  };

  return (
    <div className="patient-lookup-panel">
      <h2 className="patient-lookup-panel__heading">
        Look up patient eligibility
      </h2>

      <form className="patient-lookup-panel__form" onSubmit={handleSubmit}>
        <input
          type="text"
          className="patient-lookup-panel__input"
          value={input}
          onChange={e => {
            setInput(e.target.value);
            if (error) setError(null);
          }}
          placeholder="Patient GUID"
        />
        <button
          type="submit"
          className="patient-lookup-panel__submit"
          disabled={!input.trim()}
        >
          Check eligibility
        </button>
      </form>

      {error && <p className="patient-lookup-panel__error">{error}</p>}

      {selectedGuid && (
        <ActionModal
          title="Eligibility check"
          onClose={() => setSelectedGuid(null)}
        >
          <EligibilityDetail patientGuid={selectedGuid} />
        </ActionModal>
      )}
    </div>
  );
};

export default PatientLookupPanel;
